import { withContext } from '@hilma/tools';
import { AuthContext } from '../context';
/**
 * Function that returns a Higher Order Component with the `AuthContext` value injected via the `auth` prop
 * @param Component the component you want to inject the `AuthContext` value into
 */
var withAuth = withContext({ auth: AuthContext });
export default withAuth;
//# sourceMappingURL=withAuth.js.map